import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import DescriptionIcon from '@material-ui/icons/Description';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import { labels } from '../constants';
import { RootState } from '../../../../../redux/root';
import openInNewTab from '../../../../../utils/openInNewTab';

// Read-only in the Inspector Module: staff own the link on Permit Details, the
// inspector only needs to open it. Sits next to Gate Code so both pieces of
// "how do I get in / what am I inspecting against" live together.
const ApprovedPlans = () => {
  const { selectedInspection } = useSelector((s: RootState) => s.inspections);
  const approvedPlans = selectedInspection?.approvedPlans;

  return (
    <Field>
      <FieldLabel>{labels.approvedPlans}</FieldLabel>
      {approvedPlans ? (
        <LinkButton type="button" onClick={() => openInNewTab(approvedPlans)} title={approvedPlans}>
          <DescriptionIcon />
          <LinkText>{approvedPlans}</LinkText>
          <OpenInNewIcon className="open" />
        </LinkButton>
      ) : (
        <Placeholder>No approved plans link</Placeholder>
      )}
    </Field>
  );
};

export default ApprovedPlans;

const Field = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 0;
`;

const FieldLabel = styled.label`
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--mainText);
  margin-bottom: 8px;
`;

const LinkButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  min-width: 0;
  height: 40px;
  padding: 0 12px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--neutral-0);
  box-sizing: border-box;
  font-family: inherit;
  font-size: 0.875rem;
  color: var(--primary-700);
  text-align: left;
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  svg {
    font-size: 18px;
    flex-shrink: 0;
    color: var(--neutral-500);
  }
  svg.open {
    margin-left: auto;
    font-size: 16px;
  }

  &:hover {
    border-color: var(--neutral-400);
  }
  &:focus-visible {
    outline: none;
    box-shadow: var(--shadow-focus);
  }
`;

const LinkText = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const Placeholder = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  min-width: 0;
  height: 40px;
  padding: 0 12px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--neutral-0);
  font-size: 0.875rem;
  color: var(--neutral-400);
  box-sizing: border-box;
`;
